import { useHistory } from "react-router-dom";
import { Page } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";

import { Header } from "../../components";
import { CreateOrgForm } from "./CreateOrgForm";

export const CreateOrg = () => {
  const [isPlatformAdmin, setPlatformAdmin] = useState(
    window?.localStorage?.getItem("IS_PLATFORM_ADMIN")
      ? window?.localStorage?.getItem("IS_PLATFORM_ADMIN")
      : ""
  );

  let history = useHistory();
  useEffect(() => {
    async function fetchData() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setPlatformAdmin(
          user?.attributes["custom:plat_admin"]
            ? user?.attributes["custom:plat_admin"]
            : ""
        );
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  if (isPlatformAdmin?.toString() === "true") {
    return (
      <Page
        title="FlukeWorks"
        // style={{ backgroundColor: "#fff", minHeight: "calc(100vh - 52px)" }}
      >
        <Header xl name="Create an Organization" history={history} />
        <CreateOrgForm />
      </Page>
    );
  } else {
    history && history.push("/");
    return null;
  }
};
